import { render, staticRenderFns } from "./Sbgz.vue?vue&type=template&id=d2b87268&scoped=true"
import script from "./Sbgz.vue?vue&type=script&lang=js"
export * from "./Sbgz.vue?vue&type=script&lang=js"
import style0 from "./Sbgz.vue?vue&type=style&index=0&id=d2b87268&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2b87268",
  null
  
)

export default component.exports